import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { Modal, Button } from "react-bootstrap";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from "react-router-dom";

const EditTemperature = ({ show, onClose, id, onUpdated }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  // Form state
  const [temperatureName, setTemperatureName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);

  // Units options for select
  const [itemQuantityOptions, setItemQuantityOptions] = useState([]);

  // Loading state (optional)
  const [loading, setLoading] = useState(false);

  // Fetch units for the select dropdown
  useEffect(() => {
    const fetchUnitsByCategory = async () => {
      try {
        const response = await axios.get(`${baseURL}/manageunit/by-category`, {
          params: { unit_category_sno: 6 },
        });

        if (response.data.success) {
          const options = response.data.data.map((unit) => ({
            value: unit.unit_name, // <-- IMPORTANT: Use sno for backend update
            label: unit.unitslug_name,
          }));
          setItemQuantityOptions(options);
        } else {
          setItemQuantityOptions([]);
        }
      } catch (err) {
        console.error("Error fetching units:", err);
        setItemQuantityOptions([]);
      }
    };

    if (baseURL) {
      fetchUnitsByCategory();
    }
  }, [baseURL]);

  // Fetch duration details by id and set form fields
  useEffect(() => {
    if (!id) return;

    const fetchTemperature = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseURL}/manage-temperature/${id}`);

        if (response.data.message === "Temperature fetched successfully") {
          const data = response.data.data;

          setTemperatureName(data.temperature_name || "");
          setDescription(data.description || "");

          // Find the option matching the duration's unit sno
          const unitOption = itemQuantityOptions.find(
            (opt) => opt.value === data.unit
          );

          // If options not loaded yet, we can wait or set null and set later:
          setSelectedOption(unitOption || null);
        }
      } catch (error) {
        console.error("Error fetching duration:", error);
      }
      setLoading(false);
    };

    fetchTemperature();
  }, [id, baseURL, itemQuantityOptions]); 

  // Handle form submission
  const handleUpdate = async () => {
    if (!temperatureName || !selectedOption) {
      alert("Please fill all required fields");
      return;
    }

    try {
      const response = await axios.put(`${baseURL}/manage-temperature/${id}`, {
        temperature_name: temperatureName,
        unit: selectedOption.value,
        description,
      });

      if (response.status === 200) {
        onUpdated && onUpdated(response.data.data);
        onClose();
        toast.success("Temperature Updated successfully!");
      }
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Update Failed");
      alert("Failed to update duration.");
    }
  };

  return (
    <Modal show={show} size="md" onHide={onClose}>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: "#3ab384" }}>
          <h3 className="modal-title text-white">Update Duration</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>

        <div className="modal-body">
          {loading ? (
            <div>Loading...</div>
          ) : (
            <div className="row">
              <div className="col-lg-6 mb-2">
                <label className="text-black font-w500 fs-7">
                  Temperature<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Duration"
                  value={temperatureName}
                  onChange={(e) => setTemperatureName(e.target.value)}
                />
              </div>

              <div className="col-lg-6 mb-2">
                <label className="text-black font-w500 fs-7">
                  Unit<span className="required">*</span>
                </label>
                <Select
                  value={selectedOption}
                  onChange={setSelectedOption}
                  options={itemQuantityOptions}
                  placeholder="Select Units"
                />
              </div>

              <div className="col-lg-12 mb-2">
                <label className="text-black font-w500 fs-7">Description</label>
                <textarea
                  rows={4}
                  className="form-control h-auto"
                  name="comment"
                  placeholder="Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
          )}
          <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={handleUpdate}
              disabled={loading}
            >
              Update Temperature <i className="fas fa-angle-double-right ms-2"></i>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditTemperature;
